<template>
  <img class="picture" :src="src" :alt="alt" />
</template>
<script>
export default {
  name: 'Picture',
  props: {
    src: {
      required: true
    },
    alt: {
      default: 'image',
      required: false
    }
  }
};
</script>
<style lang="sass" scoped>
.picture
  width: 64px
  height: 64px
  min-width: 64px
  min-height: 64px
  border-radius: 4px
  margin-right: 24px
</style>
